<template>
  <div v-if="privateChatPost" class="edit-post-wrapper">
    <proa-textarea
      v-model="privateChatPost.content"
      ref="textarea"
      :attachments="privateChatPost.privateChatAttachmentsAttributes"
      :defaultValue="privateChatPost.content"
      :placeholder="$t('common.chatTextAreaPlaceHolder')"
      :quotationMode="quotationMode"
      :disabled="httpRequesting"
      :key="privateChatPostRenderingKey"
      @toggleQuotationMode="(mode) => { this.quotationMode = mode }"
      @onClickRemoveAttachment="(index) => { this.$emit('onClickRemoveAttachment', index) }"
      @onSubmitChatPost="onSubmitChatPost"
    />
    <div class="chat-assets">
      <div class="post-tools">
        <div
          v-if="mentionUserSelectModal"
          class="mention-select-modal"
        >
          <div
            v-for="user in users"
            :key="user.id"
            class="user"
            @click="onClickMentionUser(user)"
          >
            <proa-avatar :src="user.meta.avatar || require('@/assets/images/avatar_default.png')" size="xs"/>
            <span class="display-name">{{ user.meta.displayName }}</span>
          </div>
        </div>
        <!-- <proa-tool-icon
          :src="require('@/assets/images/chat_tool_icons/mention.png')"
          @click.native="onClickMentionUserSelect"
          v-click-outside="() => mentionUserSelectModal = false"
        /> -->
        <proa-tool-icon
          :src="require('@/assets/images/chat_tool_icons/attachment.png')"
          :noSmMargin="type == 'edit'"
          @click.native="onClickNewAttachment"
        />
        <proa-tool-icon
          :src="require('@/assets/images/chat_tool_icons/quotation.png')"
          :noSmMargin="type == 'edit'"
          :active="quotationMode"
          @click.native="onClickQuotationMode"
        />
      </div>
      <div v-if="type == 'new'">
        <span v-if="enabledSendChatPost" class="chat-send-support">{{ $t('common.chatSendSupport') }}</span>
        <proa-button
          variant="primary"
          class="chat-send"
          :disabled="httpRequesting || !enabledSendChatPost"
          @click.native="onSubmitChatPost"
        >
          <img :src="require('@/assets/images/chat_tool_icons/send.png')"/>
        </proa-button>
      </div>
      <div v-else-if="type == 'edit'">
        <span v-if="enabledSendChatPost" class="chat-send-support">{{ $t('common.chatSendSupport') }}</span>
        <proa-button
          variant="light"
          class="edit-cancel"
          :disabled="httpRequesting"
          @click.native="emit('onCancelEditChatPost')"
        >
        <span class="d-none d-sm-block">{{ $t('common.cancel') }}</span>
        <img class="d-block d-sm-none" :src="require('@/assets/images/chat_tool_icons/thread.png')"/>
        </proa-button>
        <proa-button
          variant="primary"
          class="chat-save"
          :disabled="httpRequesting || !enabledSendChatPost"
          @click.native="onSubmitChatPost"
        >
        <span class="d-none d-sm-block">{{ $t('common.save') }}</span>
        <img class="d-block d-sm-none" :src="require('@/assets/images/chat_tool_icons/send.png')"/>
        </proa-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ClickOutside from 'vue-click-outside'
import User from '@/store/models/User'

export default {
  name: 'PrivateChatPostEditor',
  props: {
    privateChatPost: Object,
    privateChatPostRenderingKey: Number,
    type: {
      type: String,
      default: 'new'
    }
  },
  directives: {
    ClickOutside
  },
  computed: {
    enabledSendChatPost: function() {
      return this.privateChatPost.content.trim() ||
             this.privateChatPost.privateChatAttachmentsAttributes.filter(attachment => !attachment._destroy).length >= 1
    },
    users: function() {
      return User.all()
    },
    ...mapGetters({
      httpRequesting: 'httpRequesting'
    })
  },
  data() {
    return {
      quotationMode: false,
      mentionUserSelectModal: false
    }
  },
  methods: {
    emit: function(emitString) {
      this.$emit(emitString)
      this.resetMode()
    },
    resetMode: function() {
      this.quotationMode = false
    },
    onClickMentionUserSelect: function() {
      if (this.httpRequesting) return
      this.mentionUserSelectModal = true
    },
    onClickMentionUser: function(user) {
      const textAreaComponent = this.$refs.textarea
      const position = textAreaComponent.$refs.proaTextarea.selectionStart
      const currentValue = textAreaComponent.$refs.proaTextarea.value
      textAreaComponent.$refs.proaTextarea.value = currentValue.slice(0, position)
                                                 + `@[${user.meta.displayName}:${user.id}] `
                                                 + currentValue.slice(position, currentValue.length)
      textAreaComponent.fireInputTextarea()
    },
    onClickNewAttachment: function() {
      if (this.httpRequesting) return
      this.$emit('onClickNewAttachment')
    },
    onClickQuotationMode: function() {
      if (this.httpRequesting) return
      this.quotationMode = !this.quotationMode
    },
    onSubmitChatPost: function() {
      if (!this.enabledSendChatPost) return
      this.emit('onSubmitChatPost')
    }
  }
}
</script>

<style scoped lang="scss">
</style>
